export const DEFAULT_RESTAURANT_IMAGE =
  '/static/media/sun-logo.b9800609521a5823346b.png';
